export const SET_QUICK_VIEW = 'SET_QUICK_VIEW';
export const UPDATE_QUICK_VIEW_TEMPLATE_ID = 'UPDATE_QUICK_VIEW_TEMPLATE_ID';
